module.exports = __webpack_public_path__ + "static/logo-beyondblue-537dba91b2d41b97d90971934962d47f.png";